import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import BrowseTiles from '../BrowseTiles/BrowseTiles';
import PageNotFoundHeader from '../PageNotFoundHeader/PageNotFoundHeader';

const mapStateToProps = state => ({
  s3BasePath: state.api.s3BasePath,
});

const PageNotFoundComponent = ({ isDesktop, s3BasePath }) => (
  <BrowseTiles isDesktop={isDesktop} s3BasePath={s3BasePath}>
    <PageNotFoundHeader />
  </BrowseTiles>
);

PageNotFoundComponent.propTypes = {
  isDesktop: PropTypes.bool,
  s3BasePath: PropTypes.string.isRequired,
};

const PageNotFound = connect(mapStateToProps)(PageNotFoundComponent);
export default PageNotFound;
